import { createSlice } from "@reduxjs/toolkit";
import { checkTokenExists } from "../../utils/localStorageFunction";
import { getUserRoleFromToken } from "../../utils/utils";

const initialState = {
  isAuthenticated: checkTokenExists(),
  userRole: getUserRoleFromToken() || "",
  portalViewTenant: "",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authSliceLogin: (state, action) => {
      state.isAuthenticated = true;
    },
    authSliceLogout: (state) => {
      state.isAuthenticated = false;
    },
    setUserRole: (state, action) => {
      state.userRole = action.payload;
    },
    setPortalViewTenant: (state, action) => {
      state.portalViewTenant = action.payload;
    },
  },
});

export const {
  authSliceLogin,
  authSliceLogout,
  setUserRole,
  setPortalViewTenant,
} = authSlice.actions;
export default authSlice.reducer;
